import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';

const Button = styled.a`
  display: none;
  height: 34px;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  margin-left: 24px;
  background-color: ${themeGet('colors.white')};
  color: ${props => props.color};
  border: 1px solid ${props => props.color};
  border-radius: 8px;
  white-space: nowrap;
  text-align: center;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: initial;
  }

  :hover {
    border: 1px solid ${props => props.color}60;
    color: ${props => props.color}60;
    background-color: ${themeGet('colors.white')};
  }

  :active {
    color: ${themeGet('colors.black.100')};
    border: 1px solid ${themeGet('colors.black.100')};
    background-color: ${themeGet('colors.white')};
    opacity: 1;
  }
`;

const handleClick = event => {
  event.preventDefault();

  const tileForm = window.Airbo.TileFormModal;
  tileForm.init(window.Airbo.SuggestedTileManager);
  tileForm.open('/suggested_tiles/new');
};

const SuggestTileButton = ({ color }) => {
  return (
    <Button color={color} onClick={handleClick}>
      <span>Suggest Tile</span>
    </Button>
  );
};

SuggestTileButton.propTypes = {
  color: PropTypes.string,
};

export default SuggestTileButton;
